var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckout1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checkout",
    transform: "translate(-158 -251)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1535",
    "data-name": "Ellipse 1535",
    cx: 32,
    cy: 32,
    r: 32,
    transform: "translate(158 251)",
    fill: "rgba(39,174,96,0.19)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "passenger_1_",
    "data-name": "passenger (1)",
    transform: "translate(174 263.8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35993",
    "data-name": "Path 35993",
    d: "M280.871,6.774a3.391,3.391,0,1,0-3.157-3.609A3.391,3.391,0,0,0,280.871,6.774Z",
    transform: "translate(-259.839 0)",
    fill: "#27ae60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35994",
    "data-name": "Path 35994",
    d: "M51.093,276.259a2.469,2.469,0,0,1-.543-.313l-2.2,4.772-1.648-.76a1.279,1.279,0,0,0-1.7.626l-4.349,9.432a1.279,1.279,0,0,0,.626,1.7l.561.259a1.015,1.015,0,1,0,1.705.786l.561.259a1.279,1.279,0,0,0,1.7-.626l4.349-9.432a1.278,1.278,0,0,0-.438-1.589l2.269-4.921a2.456,2.456,0,0,1-.892-.19Z",
    transform: "translate(-40.538 -255.158)",
    fill: "#27ae60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35995",
    "data-name": "Path 35995",
    d: "M194.043,108.633l-4.6-1.157-2.075-2.391.042-.627a2.29,2.29,0,0,0-2.133-2.438l-4.076-.273a2.291,2.291,0,0,0-2.425,2l.931-.268-3.761,2.009a1.547,1.547,0,0,0-.7.768l-2.426,5.8a1.547,1.547,0,1,0,2.855,1.194l2.214-5.295,3.275-1.75-2.4,2.031-.347.829-.437,6.542h.022c0,.075.221,4.454.328,6.6l-3.617,7.8a1.857,1.857,0,0,0,3.369,1.562l3.81-8.217a1.856,1.856,0,0,0,.17-.873l-.33-6.626.837.056,2.054,6.109.78,8.931a1.857,1.857,0,1,0,3.7-.323l-.8-9.152a1.856,1.856,0,0,0-.09-.43l-1.637-4.867.051,0,.449-6.716.351.4a1.547,1.547,0,0,0,.791.486l5.067,1.275a1.547,1.547,0,0,0,.755-3Z",
    transform: "translate(-162.75 -94.078)",
    fill: "#27ae60"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckout1);
export default __webpack_public_path__ + "static/media/checkout1.6fe343ff45e19f8e28418569b63d12a4.svg";
export { ForwardRef as ReactComponent };